// extracted by mini-css-extract-plugin
export var actionButton = "_ko-t";
export var buttonContainer = "_ko-0";
export var buttonContainer2 = "_ko-1";
export var buttonSection = "_ko-2";
export var details = "_ko-3";
export var dropdownItem = "_ko-5";
export var dropdownItemsContainer = "_ko-4";
export var fileInput = "_ko-r";
export var headerButton = "_ko-6";
export var icon = "_ko-7";
export var input = "_ko-8";
export var macroListItem = "_ko-9";
export var mainContent = "_ko-a";
export var microText = "_ko-b";
export var modal = "_ko-w";
export var optionsButton = "_ko-c";
export var paperclip = "_ko-s";
export var pillContent = "_ko-d";
export var preview = "_ko-e";
export var preview2 = "_ko-f";
export var quillEditor = "_ko-q";
export var selectedMacro = "_ko-g";
export var sidebar = "_ko-h";
export var sidebarHeader = "_ko-j";
export var sidebarList = "_ko-i";
export var sidebarListItem = "_ko-k";
export var sidebarSearch = "_ko-l";
export var snoozeDurationWrapper = "_ko-v";
export var statusPillContainer = "_ko-m";
export var tagsContainer = "_ko-n";
export var unselectedMacro = "_ko-o";
export var variable = "_ko-u";
export var wrapper = "_ko-p";